import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

// All props are optional since each value has a default value or fallback
// https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component

export const Seo = ({ title, description, pathname, keywords, children }) => {
  const { title: defaultTitle, description: defaultDescription,  siteUrl, image, keywords: defaultKeywords } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    keywords: keywords || defaultKeywords,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="keywords" content={seo.keywords} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      
      {children}
    </>
  )
}